import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'

import { parseISO } from '@util/date-util'

interface FilterFromToWeekProps {
  fromWeek: string
  toWeek: string
  onFilterChange: (filter: Record<string, string>) => void
  label: string
  fromKey?: string
  toKey?: string
  variant?: 'outlined' | 'standard' | 'filled'
}

export default function FilterFromToWeek({
  fromWeek,
  toWeek,
  onFilterChange,
  label,
  fromKey = 'fromWeek',
  toKey = 'toWeek',
  variant = 'standard',
}: FilterFromToWeekProps) {
  return (
    <Box sx={{ display: 'flex', gap: 2 }}>
      <TextField
        variant={variant}
        value={fromWeek}
        label={`${label} van`}
        fullWidth
        onChange={(e) => onFilterChange({ [fromKey]: e.target.value })}
        error={fromWeek !== '' && isNaN(parseISO(fromWeek).getTime())}
        placeholder="bijv. 2023-W01"
      />
      <TextField
        variant={variant}
        value={toWeek}
        label={`${label} tot`}
        fullWidth
        onChange={(e) => onFilterChange({ [toKey]: e.target.value })}
        error={toWeek !== '' && isNaN(parseISO(toWeek).getTime())}
        placeholder="bijv. 2023-W01"
      />
    </Box>
  )
}
